import {Component} from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: false
})

/**
 * Footer Component
 */
export class FooterComponent {
  year: number = new Date().getFullYear();
}
